import React from 'react';
import { Modal, Table, Descriptions, Empty } from 'antd';
import type { ColumnsType } from 'antd/es/table';

interface Payment {
  sp_payment_id: string | number;
  sp_payment_amount: number;
  sp_payment_date: string;
  sp_payment_method: string;
  sp_payment_status: string;
}

interface Subscription {
  subscription_id: number | string;
  package_name: string;
  organization_name: string;
  subscription_expire_status: string;
  subscription_expiry_date: string;
  subcription_amount: string | number;
  subcription_discount: string | number;
  subcription_after_discount_amount: string | number;
}

interface PaymentDetailsModalProps {
  ispaymentviewModalVisible: boolean;
  closePaymentViewModal: () => void;
  subscription?: Subscription | null;  // Make optional/nullable
  payments: Payment[];
}

const paymentColumns: ColumnsType<Payment> = [
  { title: 'Payment ID', dataIndex: 'sp_payment_id', key: 'id' },
  { title: 'Amount', dataIndex: 'sp_payment_amount', key: 'amount', render: (val?: number) => val ? `₹ ${val}` : '₹ 0.00', },
  { title: 'Date', dataIndex: 'sp_payment_date', key: 'date' },
  { title: 'Method', dataIndex: 'sp_payment_method', key: 'method' },
  { title: 'Status', dataIndex: 'sp_payment_status', key: 'status' },
];

const PaymentDetailsModal: React.FC<PaymentDetailsModalProps> = ({
  ispaymentviewModalVisible,
  closePaymentViewModal,
  subscription,
  payments,
}) => {
  if (!subscription) {
    return (
      <Modal
        title="Payment Details"
        open={ispaymentviewModalVisible}
        onCancel={closePaymentViewModal}
        footer={null}
        width={700}
      >
        <Empty description="No subscription selected" />
      </Modal>
    );
  }
  
  return (
    <Modal
      title="Payment Details"
      open={ispaymentviewModalVisible}
      onCancel={closePaymentViewModal}
      footer={null}
      width={700}
    >
      <Descriptions bordered column={1} size="middle" style={{ marginBottom: 24 }}>
        <Descriptions.Item label="Package Name">{subscription.package_name}</Descriptions.Item>
        <Descriptions.Item label="Organization">{subscription.organization_name}</Descriptions.Item>
        <Descriptions.Item label="Subscription Status">{subscription.subscription_expire_status}</Descriptions.Item>
        <Descriptions.Item label="Expiry Date">{subscription.subscription_expiry_date}</Descriptions.Item>
        <Descriptions.Item label="Original Amount">₹{Number(subscription.subcription_amount).toFixed(2)}</Descriptions.Item>
        <Descriptions.Item label="Discount">₹{Number(subscription.subcription_discount).toFixed(2)}</Descriptions.Item>
        <Descriptions.Item label="Amount After Discount">₹{Number(subscription.subcription_after_discount_amount).toFixed(2)}</Descriptions.Item>
      </Descriptions>

      <Table
        dataSource={payments}
        columns={paymentColumns}
        rowKey="sp_payment_id"
        pagination={false}
        locale={{ emptyText: 'No payments found' }}
      />
    </Modal>
  );
};

export default PaymentDetailsModal;
